import { Component, Input } from '@angular/core';

@Component({
  selector: 'epa-section',
  templateUrl: './epa-section.component.html',
  styleUrls: ['./epa-section.component.scss']
})
export class EpaSectionComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() iconName: string = 'folder-outline';
  @Input() variant: 'red' | 'green' = 'red';
  @Input() collapsible: boolean = false;

  expanded = true;

  toggle(): void {
    if (this.collapsible) {
      this.expanded = !this.expanded;
    }
  }
}
